import type { PrepackageSearchState } from '../../types';
import { PrepackageSearchOriginOptions } from '../data/PrepackageSearchOriginOptions';
import { formatTravelMonthsParam } from './travelParamFormatters';

export const buildPrepackageTrackingItem = (state: PrepackageSearchState) => {
    const destinationParts = state.destinationId?.split(';');

    return {
        id: 'finntravel',
        type: 'Travel',
        destination: destinationParts?.[1],
        arrivalCity: destinationParts?.[2],
        departureCountry: 'Norge',
        departureCity: PrepackageSearchOriginOptions.find((opt) => opt.value === state.originAirport)?.label,
        travelType: 'prepackage',
        departureDate: (state.searchType === 'fixed' ? state.departureDate : formatTravelMonthsParam(state.travelMonths)) || undefined,
        returnDate: (state.searchType === 'fixed' ? state.returnDate : formatTravelMonthsParam(state.travelMonths)) || undefined,
    };
};
